














import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class NavButtonItem extends Vue {
  @Prop() label!: string;
  @Prop({ default: false }) isActive?: boolean;
  @Prop({ default: 0 }) activePercentage?: number;

  get activePercentageStyle() {
    return `--active-percentage: ${this.activePercentage}%`;
  }
}
